(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/header-logo.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/header-logo.js');

'use strict';

const HeaderLogo = () => React.createElement("a", {
  href: svs.core.urlMapping.get('startPage')
}, React.createElement("div", {
  className: "u-position-absolute u-top-0 u-right-0 tur-logo-width"
}, React.createElement("img", {
  alt: "Svenska Spel Tur",
  src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/components/ao-logotype-tur/ao-tur.svg")
})));
svs.playerLoginReact.sharedComponents.HeaderLogo = HeaderLogo;

 })(window);